import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "text-lg leading-6 font-medium text-gray-900" }
const _hoisted_2 = { class: "flex mt-4 justify-end" }
const _hoisted_3 = ["disabled"]

import { Form, SubmissionHandler } from "vee-validate";
import { computed, Ref } from "vue";
import { useI18n } from "vue-i18n";
import * as yup from "yup";
import LoadingSpinner from "shared/components/loading_state/LoadingSpinner.vue";
import Modal from "shared/components/modals/Modal.vue";
import { useCreateOrganization } from "shared/composables/organization";
import { Organization, OrganizationToCreate } from "shared/types/Organization";
import CheckboxField from "@/components/forms/CheckboxField.vue";
import InputField from "@/components/forms/InputField.vue";

type OrganizationForm = {
  name: string;
  isRoot: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'AddOrganizationModal',
  props: {
    organization: {}
  },
  emits: ["close", "selectOrganization"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const props = __props;
const emit = __emit;

const { createOrganization } = useCreateOrganization();

const schema = yup.object({
  name: yup.string().required(t("organizations.validation_field_required")),
});

const initialValues: Ref<OrganizationForm> = computed(() => ({
  name: "",
  isRoot: !props.organization,
}));

const handleSubmit: SubmissionHandler = async (genericObject) => {
  const values = genericObject as OrganizationForm;
  const payload: OrganizationToCreate = {
    name: values.name,
    parent_id: values.isRoot ? null : props.organization?._id ?? null,
    explicit_projects: [],
  };
  const result = await createOrganization(payload).catch(() => undefined);
  if (result) {
    emit("selectOrganization", result.created_organization._id);
    emit("close");
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    open: true,
    onClose: _cache[0] || (_cache[0] = ($event: any) => (emit('close'))),
    customCls: "w-full m-2 lg:w-1/3"
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)("organizations.add_organization")), 1)
    ]),
    content: _withCtx(() => [
      _createVNode(_unref(Form), {
        onSubmit: handleSubmit,
        initialValues: initialValues.value,
        validationSchema: _unref(schema),
        class: "text-left flex flex-col gap-4"
      }, {
        default: _withCtx(({ isSubmitting, values }) => [
          _createVNode(InputField, {
            name: "name",
            label: _unref(t)('organizations.organization_name')
          }, null, 8, ["label"]),
          _createVNode(CheckboxField, {
            name: "isRoot",
            label: _unref(t)('organizations.root')
          }, null, 8, ["label"]),
          _createElementVNode("div", null, _toDisplayString(_unref(t)("organizations.parent")) + ": " + _toDisplayString(!values.isRoot && _ctx.organization ? _ctx.organization.name : _unref(t)("organizations.root")), 1),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              type: "submit",
              class: "focus:outline-none flex justify-center rounded-md border border-transparent bg-yellow-500 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-yellow-600 focus:ring-0 disabled:cursor-default disabled:bg-gray-300",
              disabled: isSubmitting
            }, [
              isSubmitting
                ? (_openBlock(), _createBlock(LoadingSpinner, {
                    key: 0,
                    size: "w-5 h-5",
                    color: "white",
                    class: "mr-2"
                  }))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_unref(t)("buttons.create")), 1)
            ], 8, _hoisted_3)
          ])
        ]),
        _: 1
      }, 8, ["initialValues", "validationSchema"])
    ]),
    _: 1
  }))
}
}

})